import React from 'react'
import { FormProvider } from 'react-hook-form'
import { FinancingUxFeedbackModalFormActions } from './FinancingUxFeedbackModalFormActions'
import { FinancingUxFeedbackModalFormComment } from './FinancingUxFeedbackModalFormComment'
import { FinancingUxFeedbackModalFormGrade } from './FinancingUxFeedbackModalFormGrade'
import { FinancingUxFeedbackModalFormTitle } from './FinancingUxFeedbackModalFormTitle'
import { useUxFeedbackForm } from './hooks'
import type { IFinancingUxFeedbackModalFormProps } from './types'
import './styles.scss'

export const FinancingUxFeedbackModalForm = (props: IFinancingUxFeedbackModalFormProps) => {
  const { onSuccess, onError, isHasSkipButton, onSkipAction, onCustomSuccessAction } = props

  const onErrorHandle = onCustomSuccessAction || onError
  const { handleSubmit, onSubmitForm, formMethods, isNotDisabledAction } = useUxFeedbackForm(onSuccess, onErrorHandle)

  return (
    <div className="financingUxFeedbackModal">
      <FinancingUxFeedbackModalFormTitle />

      <form onSubmit={handleSubmit(onSubmitForm)}>
        <FormProvider {...formMethods}>
          <FinancingUxFeedbackModalFormGrade />
          <FinancingUxFeedbackModalFormComment />
          <FinancingUxFeedbackModalFormActions
            isNotDisabledAction={isNotDisabledAction}
            isHasSkipButton={isHasSkipButton}
            onSkipAction={onSkipAction}
          />
        </FormProvider>
      </form>
    </div>
  )
}
